// Import basic libraries used throughout all applications
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';

// Import plugins from the eflib
import auth from '@lib/plugins/auth';
import '@lib/plugins/axios';
import Moment from '@lib/plugins/moment';
import AsteriskPlugin from '@/plugins/asterisk';
import DownloadPlugin from '@/plugins/downloads';
import PhoneNumberPlugin from './plugins/phone_numbers';

// Load Font Awesome icons
import '@lib/../assets/fontawesome-pro-6.4.2-web/css/all.min.css';
import '@lib/../assets/fontawesome-pro-6.4.2-web/css/solid.min.css';
import '@lib/../assets/fontawesome-pro-6.4.2-web/css/brands.min.css';

// Bootstrap the main application layout from the eflib
import '@lib/plugins/bootstrap';
import App from '@lib/layouts/Base.vue';

// Import application specific code
import router from '@/router';

// Load button helper CSS. Loading order is important on CSS files!
import '@lib/../assets/css/overwrites/buttons.css';
import '@lib/../assets/css/overwrites/margins.css';

// Initialize localization
import { createI18n } from 'vue-i18n';
import { merge } from 'lodash-es';

import lib_locale from '@lib/locale';
import app_locales from '@/locale/index';

const i18n = createI18n({
	locale: window.navigator.language.replace(/[-_].*$/, ''),
	fallbackLocale: 'en',
	globalInjection: true,
	messages: merge(lib_locale, app_locales),
});

// Create main vue app
const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(auth);
app.use(i18n);
app.use(PrimeVue);
app.use(Moment);
app.use(AsteriskPlugin);
app.use(DownloadPlugin);
app.use(PhoneNumberPlugin);

// Load additional components from the ef libraray, eg. the layouts sidebar
// We use the plugin system style to ensure that the components are loaded in the proper order
import EfLib from '@lib/eflib';
app.use(EfLib, {
	search: (s: string) => {},
});

import Sidebar from '@/plugins/sidebar';
app.use(Sidebar);

// The context works pretty much the same in all apps and is only customized in the app
import { AppApplicationPlugin } from '@lib/plugins/layouts/application';
app.use(AppApplicationPlugin);

import AppFilterPlugin from '@/plugins/filters';
app.use(AppFilterPlugin);

import EfFilterPlugin from '@lib/filters';
app.use(EfFilterPlugin);

// Mount the app
app.mount('#app');
